var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManBeard5C(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "type3_x5F_beards"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x32_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DEA65F",
    d: "M375.4,334.5c-2,0.1-4,0.1-6,0.4c-2.7,0.5-1.8,3.9-1.8,5.9c0.1,1.7-0.4,4.4,1.4,5.3 c1.9,0.9,5.2,0.4,7.2,0.6c9.8,0.9,18.7,0.4,27.5,2.9c2,0.6,4,1.3,5.9,2.3c1.3,0.7,5.2,3.5,6.6,3.1c3.3-0.8-5.3-8.9-6.6-10 c-7.7-6.7-16.5-9.5-26.5-10.2C380.6,334.5,378,334.5,375.4,334.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DEA65F",
    d: "M346.7,336c2-0.1,4-0.2,6,0c2.8,0.3,2.1,3.8,2.1,5.8c0.1,1.7,0.6,4.4-1.1,5.4c-1.8,1.1-5.2,0.7-7.2,1 c-9.7,1.4-18.6,1.5-27.3,4.5c-2,0.7-3.9,1.6-5.8,2.6c-1.3,0.7-5,3.8-6.4,3.5c-3.3-0.6,4.8-9.2,6-10.4c7.2-7.1,15.9-10.5,25.9-11.8 C341.5,336.4,344.1,336.3,346.7,336"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DEA65F",
    d: "M335.8,425.5L335.8,425.5L335.8,425.5C335.7,425.6,335.7,425.6,335.8,425.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DEA65F",
    d: "M396.8,392c-4.7,2.6-10.2,4.2-14.7,3.7c-5.7-0.7-15.1-4.9-20.5-5.2c-5.9-0.4-9.2,2.2-15.2,4 c-5.3,1.6-8.6,4-14.2,2.4c-4.9-1.4-9.4-3.5-14.2-5.6c-3.9-1.7-7.8-3.4-11.3-5.6c3.3,3.5,5,8.3,8.1,12c3.3,4,7,7,9.9,11.4 c2.2,3.3,4.8,6,4.5,10.4c2.5-2.9,3.5-5,3.1-8.8c2.9,2.7,5,11.1,3.7,14.9c3.4-1.9,5.8-4.4,7.2-8c0.7,3.9,0,9.4-2.8,12.5 c3.8-0.9,9.2-3.7,11-7.7c0.9,6.6,2.3,10.3,8.2,14.1c3.9-4,8.6-6.8,10.9-12.6c0.8,3.4,1.3,6.6,4.6,8.4c-0.6-4.5,0.6-10.7,1.8-15 c0.2,3.3,1.3,6.5,3.7,8.8c1.2-4.6,5.4-9.2,8.5-12.8c3.4-3.9,6.5-8,10-11.9c2.5-2.8,4.9-5.8,7.1-8.8c1.4-1.9,4.5-5.6,5.4-7.1 C404.5,388,401.4,389.4,396.8,392z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManBeard5C);
export default __webpack_public_path__ + "static/media/man_beard_5c.581b9055c1a89b77a4f1fbe99236ce4f.svg";
export { ForwardRef as ReactComponent };